// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import vacatures from './routes/vacatures';
import formulieren from './routes/formulieren';
import formulier from './routes/formulier';
import loket from './routes/loket';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  aboutUs,
  vacatures,
  formulieren,
  formulier,
  loket,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

setOffsetHeight();


function setOffsetHeight() {

  //document query by id
  var header = document.getElementById('header');
  if (!header) {return;}

  //Scroll positie
  let navigationHeight = header.offsetHeight;
  let scrollpos = window.scrollY;

  window.addEventListener('load', () => {
    
    navigationHeight = header.offsetHeight;
    // console.log(navigationHeight);
    document.documentElement.style.setProperty('--scroll-padding', navigationHeight +'px');

  });

  // update on scroll:
  window.addEventListener('scroll', function() { 

    scrollpos = window.scrollY;
    //add or remove class
    if (scrollpos >= 200 ) { 
      header.classList.add('show');
    }
    else { 
      header.classList.remove('show');
    }
  })

  return navigationHeight;
}


// WEBPACK FOOTER //
// ./scripts/main.js